import { Component, inject, ViewChild } from "@angular/core";
import { SideDialogComponent } from "@app/kernel/popups/popups.config";
import { EmailFormModel } from "../../models/email-form.model";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ProfileService } from "@app/applications/profile/services/profile.service";
import { UpdateEmailFormComponent } from "../../components/update-email-form/update-email-form.component";
import { ButtonComponent } from "@app/kernel/shared/modules/button/components/button/button.component";
import { SxwFormComponent } from "@app/kernel/form/components/sxw-form/sxw-form.component";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-update-email",
  imports: [UpdateEmailFormComponent, SideDialogComponent, ButtonComponent, SxwFormComponent, CommonModule, TranslateModule, SideDialogComponent],
  templateUrl: "./update-email.component.html",
  styleUrl: "./update-email.component.scss",
  providers: [EmailFormModel],
})
export class UpdateEmailComponent {
  readonly formModel = inject(EmailFormModel);
  private readonly router = inject(Router);
  private readonly translate = inject(TranslateService);
  private readonly profileService = inject(ProfileService);
  public route = inject(ActivatedRoute);

  isLoading = false;
  @ViewChild(SideDialogComponent) sideDialog!: SideDialogComponent;
  isDialogVisible = true;

  hideDialog() {
    this.router.navigate(["/profile"]);
  }
  async submit(): Promise<void> {
    if (this.formModel.formStatus() !== "VALID") return;
    this.isLoading = true;
    const formValue = this.formModel.formGroup().getRawValue();
    const dto = this.formModel.formValueToDtoInput(formValue);

    this.profileService.updateMyEmail(dto).subscribe({
      next: () => {
        this.handleResetPasswordSuccess();
        this.isDialogVisible = false;
      },
      error: () => {
        this.handleResetPasswordErrors();
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  handleResetPasswordSuccess(): void {
    this.isDialogVisible = false;
    this.router.navigate([{ outlets: { popups: ["verify-update-email-otp"] } }], { relativeTo: this.route.parent });
  }

  private handleResetPasswordErrors(): void {
    this.isLoading = false;
  }
}
